module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("aOzZC"))).then(() => parcelRequire('86UKy'));